import { DateInterval } from '../OrchestratorTracker/components/OrchestratorGeneralInfo/components/DateInterval';
import { DateDuration } from '../OrchestratorTracker/components/OrchestratorGeneralInfo/components/DateDuration';
import LiveDuration from '../OrchestratorTracker/components/OrchestratorGeneralInfo/components/LiveDuration';

interface Props {
  status?: string;
  startAt?: string;
  endAt?: string;
  updatedAt?: string;
}

export const StatusDates = ({ status, startAt, endAt, updatedAt }: Props) => {
  const normalizedStatus = status === 'REJECTED' ? 'COMPLETED' : status;

  if (normalizedStatus === 'COMPLETED') {
    return (
      <div className="d-flex justify-content-between">
        <DateInterval startAt={startAt} endAt={endAt} />
        <DateDuration startAt={startAt} endAt={endAt} />
      </div>
    );
  }

  if (normalizedStatus === 'IN_PROGRESS') {
    return (
      <div className="d-flex justify-content-between">
        <DateInterval startAt={startAt} updatedAt={updatedAt} />
        <LiveDuration startAt={startAt} lastUpdated={updatedAt} />
      </div>
    );
  }

  return null;
};
